// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Vi0a3","diasbledText":"styles_diasbledText__gGgyy"};